import React from 'react';
import StepShell from '../StepComponents/StepShell';

class StepPromoCode extends React.Component{
    render() {
        return(
            <StepShell stepID="StepNotFound"
                friendlyText="Page Not Found"
                requestText="Sorry, but we couldn't find what you were looking for..."
                progress="5%"
                progressLabel="Not Found"
                backLink="/"                
        >

        </StepShell>
        )
    }
}

export default StepPromoCode;